import api from "../../../../api";
import React, { useState } from "react";
import values from "../../../../values";
import Context from "../../../../context";

import * as Yup from "yup";

import { useFormik } from "formik";
import { useQuery } from "react-query";
import { ICityItem, IProvinceItem } from "../../../../types/common.interface";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../components";

import "./index.sass";
import TitleLine from "../../../../components/TitleLine";
import validations from "../../../../validations";
import utils from "../../../../utils";
import { ICreateAndUpdateGovernmentShip } from "../../../../types/govenmentShip.interface";
import { useTranslation } from "react-i18next";

const Create = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createFunction, isLoading } =
    React.useContext(Context.GovernmentShipScreen);
  // const [selectedCity, setSelectedCity] = React.useState<ICityItem>();
  const [selectedProvince, setSelectedProvince] =
    React.useState<IProvinceItem>();
  const [dropDownErrors, setDropDownErrors] = useState<any>({
    province: "",
  });
  // const [selectedFinancialGroup, setSelectedFinancialGroup] =
  //   React.useState<any>(undefined);

  const { t } = useTranslation();

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );

  // const getAllCity = useQuery(
  //   [values.useQueryKeys.getAllCity, selectedProvince],
  //   () => api.get.common.getAllCity({ provinceCode: selectedProvince?.Code })
  // );

  // const getAllFinancilalGroup = useQuery(
  //   [values.useQueryKeys?.getAllFinancialGroup],
  //   () =>
  //     api.post.administrator.getAllFinancialGroup({
  //       filters: { FinancialGroupType: "company" },
  //     })
  // );

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const formik = useFormik<ICreateAndUpdateGovernmentShip>({
    enableReinitialize: true,
    initialValues: {
      name: "",
      phoneNumber: "",
    },
    validationSchema: Yup.object({
      // validation

      name: validations.yupValidations.firstName,
      phoneNumber: validations.yupValidations.phoneNumber,
    }),
    onSubmit: (values: ICreateAndUpdateGovernmentShip, { setSubmitting }) => {
      const formValues: ICreateAndUpdateGovernmentShip = {
        ...values,
        province: selectedProvince,
      };
      if (selectedProvince) {
        Promise.resolve(createFunction(formValues))
          .then((value) => {
            if (value) {
              // setSelectedCity(undefined);
              setSelectedProvince(undefined);
              // setSelectedFinancialGroup(undefined);
              formik.resetForm();
            }
          })
          .catch((e) => setSubmitting(false));
      }
    },
  });

  const submitHandler = () => {
    // validation
    let errors = {};
    if (!selectedProvince) {
      errors = {
        ...errors,
        province: t("province_is_required"),
      };
    }

    setDropDownErrors({
      ...errors,
    });

    formik.submitForm();
  };

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="super-agent-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={t("createGovernmentShip")}
        onClick={() => {
          setShowModal("CREATE");
        }}
      />
      <form onSubmit={submitHandler}>
        <CustomModal
          onClose={() => setShowModal("NONE")}
          open={showModal === "CREATE"}
        >
          <CustomView.Container className="create-form-content">
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">{t("province")}</label>
                <CustomDropdownSearch
                  items={getAllProvince?.data?.result}
                  itemName="Name"
                  defaultItem={selectedProvince}
                  onSelectItem={(event: IProvinceItem) => {
                    // setSelectedCity(undefined);
                    setSelectedProvince(event);
                    setDropDownErrors({ ...dropDownErrors, province: "" });
                  }}
                  placeHolder={t("selectProvince")}
                  isLoading={getAllProvince.isLoading}
                  isSearch
                />
                <div className="error">
                  {dropDownErrors.province !== "" && dropDownErrors.province}
                </div>
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="name"
                  id="name"
                  label={t("name")}
                  value={formik.values.name}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="phoneNumber"
                  id="phoneNumber"
                  label={t("phoneNumber")}
                  value={utils.convertNumbers2English(
                    formik.values.phoneNumber as string
                  )}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={
                    formik.errors.phoneNumber && formik.touched.phoneNumber
                  }
                  errorText={formik.errors.phoneNumber}
                  maxLength={11}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row buttons-group">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={submitHandler}
                  title={t("submit")}
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Create;
